let timer = 0

let title = null

let run = false

function init (t) {
  title = t
  if (!run) {
    start(title)
    run = true
  }
}

function start () {
  if (title) {
    const arr = title.split('')
    const e = arr.shift()
    arr.push(e)
    title = arr.join('')
    document.title = title
    // eslint-disable-next-line no-implied-eval
    timer = window.setTimeout(start, 500)
  }
}

function stop (t) {
  document.title = t
  if (timer) {
    window.clearTimeout(timer)
  }
  run = false
}

export default function () {
  return {
    init: init,
    stop: stop
  }
}
